import * as types from "./types";

/**
 * `overview` holds the raw `data` object from the endpoint (PROLINE-3755) as-is
 * (snake_case) — the composing container reads the API field names directly.
 */
const initialState = {
  overview: null,
  overviewLoading: false,
  /** Raw `data` array of events_overview?status=ongoing (PROLINE-3841). */
  ongoingEvents: [],
  ongoingEventsLoading: false,
  /** Raw `data` array of client_satisfaction (PROLINE-3826). */
  clientSatisfaction: [],
  clientSatisfactionLoading: false,
  /** Raw `data` array of events_overview (PROLINE-3826), top 3 of the last 30 days. */
  topEvents: [],
  topEventsLoading: false,
  /** Raw `data` array of activity_logs (PROLINE-3925), newest 10. */
  recentActivity: [],
  recentActivityLoading: false,
};

const companyDashboard = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_DASHBOARD_OVERVIEW_REQUEST:
      return { ...state, overviewLoading: true };
    case types.GET_COMPANY_DASHBOARD_OVERVIEW_RESPONSE:
      return { ...state, overview: action.payload, overviewLoading: false };
    // A failed load only clears the loading flag — the last data stays on screen.
    case types.GET_COMPANY_DASHBOARD_OVERVIEW_FAILURE:
      return { ...state, overviewLoading: false };
    case types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_FAILURE:
      return { ...state, ongoingEventsLoading: false };
    case types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_REQUEST:
      return { ...state, ongoingEventsLoading: true };
    case types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_RESPONSE:
      return {
        ...state,
        ongoingEvents: action.payload,
        ongoingEventsLoading: false,
      };
    case types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_REQUEST:
      return { ...state, clientSatisfactionLoading: true };
    case types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_RESPONSE:
      return {
        ...state,
        clientSatisfaction: action.payload,
        clientSatisfactionLoading: false,
      };
    case types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_FAILURE:
      return { ...state, clientSatisfactionLoading: false };
    case types.GET_COMPANY_DASHBOARD_TOP_EVENTS_REQUEST:
      return { ...state, topEventsLoading: true };
    case types.GET_COMPANY_DASHBOARD_TOP_EVENTS_RESPONSE:
      return { ...state, topEvents: action.payload, topEventsLoading: false };
    case types.GET_COMPANY_DASHBOARD_TOP_EVENTS_FAILURE:
      return { ...state, topEventsLoading: false };
    case types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_REQUEST:
      return { ...state, recentActivityLoading: true };
    case types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_RESPONSE:
      return {
        ...state,
        recentActivity: action.payload,
        recentActivityLoading: false,
      };
    case types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_FAILURE:
      return { ...state, recentActivityLoading: false };
    default:
      return state;
  }
};

export default companyDashboard;
